import React, { createContext, useState } from 'react';

export const MenuButtons = createContext();

export const MenuProvider = ({ children }) => {
    const [isSoundOn, setIsSoundOn] = useState(() => {
        const savedValue = localStorage.getItem("isSoundOn");
        return savedValue ? JSON.parse(savedValue) : true; // Парсим из строки или задаем значение по умолчанию
    });

    const [isMusicOn, setIsMusicOn] = useState(() => {
        const savedValue = localStorage.getItem("isMusicOn");
        return savedValue ? JSON.parse(savedValue) : true;
    })

    const [isAnimationOn, setIsAnimationOn] = useState(() => {
        const savedValue = localStorage.getItem("isAnimationOn");
        return savedValue ? JSON.parse(savedValue) : true;
    })

    return (
        <MenuButtons.Provider value={{ isSoundOn, setIsSoundOn, isMusicOn, setIsMusicOn, isAnimationOn, setIsAnimationOn }}>{children}</MenuButtons.Provider>
    )
}